import { Component, OnInit } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { phosphorSidebarFill, phosphorSidebarSimpleFill } from '@ng-icons/phosphor-icons/fill';
import { heroChatBubbleLeftRight, heroPlus } from '@ng-icons/heroicons/outline';
import { Usdm2Service, UsdmSession } from '../../../services/ai/usdm2.service';
import { OauthService, UserInfo } from '../../../services/oauth.service';

@Component({
  selector: 'app-usdm-drawer',
  imports: [NgIcon],
  providers: [
    provideIcons({ phosphorSidebarFill, phosphorSidebarSimpleFill, heroPlus, heroChatBubbleLeftRight })
  ],
  templateUrl: './usdm-drawer.component.html',
  styleUrl: './usdm-drawer.component.css'
})
export class UsdmDrawerComponent implements OnInit {
  sessions: UsdmSession[] = [];
  userInfo: UserInfo | null = null;

  constructor(private usdmService: Usdm2Service, private oauthService: OauthService) { }

  ngOnInit(): void {
    this.getUsdmSessions();
  }

  newSession() {
    window.location.reload();
    this.closeDrawer();
  }

  async getUsdmSessions(): Promise<void> {
    if (!this.userInfo) {
      try {
        this.userInfo = await this.oauthService.getUser();
      } catch (error) {
        console.error('Error fetching user info before managing sidebar:', error);
        this.userInfo = null;
        console.warn('User info is not available, cannot manage sidebar.');
        return;
      }
    }
    this.sessions = await this.usdmService.getAllUsdmSessions();
    // console.log('Sessions:', this.sessions);
  }

  closeDrawer() {
    const drawerCheckbox = document.getElementById('my-drawer') as HTMLInputElement;
    if (drawerCheckbox) {
      drawerCheckbox.checked = false;
    }
  }

  selectSession(session: UsdmSession) {
    console.log("Selected session:", session);
    this.usdmService.setUsdmSessionId(session.session_id);
    this.usdmService.usdmSession.set(session);
    this.closeDrawer();
  }
}
